import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { PayoutIcon } from '@/shared/components/icons/PayoutIcon'
import { formatCurrency } from '@/shared/lib/currency'
import { formatDate } from '@/shared/lib/date'
import { formatRequisite } from '@/shared/lib/requisite/formatRequisite'
import { getBankMeta } from '@/shared/utils/getBankMeta'
import { ColumnDef } from '@tanstack/react-table'
import { WithdrawsModel, WithdrawStatus, WithdrawStatusIcons, WithdrawStatusTitles } from '../model'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'
import { Link } from 'react-router-dom'
import { getShortenId } from '@/shared/utils/getShortenId'

export const getColumns = (): ColumnDef<WithdrawsModel>[] => [
  {
    accessorKey: 'id',
    header: () => <div>ID заявки</div>,
    cell: ({ row }) => {
      const id = row.getValue<string>('id')
      const requestId = row.original.requestId

      return (
        <div className="flex flex-col">
          <CopyBlock text={id} title={id}>
            <Link to={id} className="text-primary">
              {getShortenId(id)}
            </Link>
          </CopyBlock>

          {requestId && (
            <CopyBlock
              text={requestId}
              title={requestId}
              color="secondary"
              className="text-xs"
            >
              request_id: {getShortenId(requestId)}
            </CopyBlock>
          )}
        </div>
      )
    },
  },
  {
    accessorKey: 'payout',
    header: 'Заявка',
    cell: ({ row }) => {
      const createdAt = row.original.createdAt || ''
      const status = row.original.withdrawStatus
      const title = WithdrawStatusTitles[status]
      const iconStatus = WithdrawStatusIcons[status]
      return (
        <ItemLayout
          icon={<PayoutIcon status={iconStatus} />}
          subtitle={new Date(createdAt).toLocaleString('ru-RU')}
          title={title}
        />
      )
    },
  },
  {
    accessorKey: 'requisite',
    header: 'Реквизит',
    cell: ({ row }) => {
      // const methodType = row.original.aMobileWithdrawMethodTypeTo
      // const requisitName = AMobileWithdrawMethodNames[methodType]
      // const requisite = formatRequisitToType(
      //   methodType === AMobileWithdrawMethodTypeTo.SberByPhone
      //     ? PaymentRequisitToType.SbpPhoneNumber
      //     : PaymentRequisitToType.CardNumber,
      //   row.original.paymentRequisitValue
      // )

      const { title } = getBankMeta(row.original.bankToName)
      return (
        <div className="flex flex-col">
          <span>{formatRequisite(row.original.paymentRequisitValue)}</span>
          <span className="text-text-secondary">{title}</span>
        </div>
      )
    },
  },
  {
    accessorKey: 'amount',
    header: 'Сумма',
    cell: ({ row }) => {
      const usdtAmount = formatCurrency(row.original.amountTo, row.original.currencyTo)
      const rubAmount = formatCurrency(
        row.original.amountTo / row.original.exchangeRateFromTo,
        row.original.currencyFrom
      )
      return (
        <div className="flex flex-col">
          <span>{usdtAmount}</span>
          <span className="text-text-secondary">{rubAmount}</span>
        </div>
      )
    },
  },
  {
    accessorKey: 'rate',
    header: 'Курс',
    cell: ({ row }) => {
      const rate = formatCurrency(row.original.exchangeRateFromTo, row.original.currencyTo)
      const time = formatDate(row.original.confirmedByTraderAt, 'timeOnly')

      const showRate = [WithdrawStatus.Paid, WithdrawStatus.PaidPartially].includes(
        row.original.withdrawStatus
      )
      if (!showRate) return null
      return (
        <div className="flex flex-col">
          {rate && time && (
            <span>
              {rate} на {time}
            </span>
          )}
        </div>
      )
    },
  },
  {
    accessorKey: 'commission',
    header: 'Комиссия',
    cell: ({ row }) => {
      if (row.original.withdrawStatus !== WithdrawStatus.Paid) return null
      const totalCommissionAmount =
        row.original.totalCommissionAmount !== undefined
          ? formatCurrency(row.original.totalCommissionAmount, row.original.currencyFrom)
          : ''

      return (
        <div className="flex flex-col">
          <span>{totalCommissionAmount}</span>
        </div>
      )
    },
  },
  {
    accessorKey: 'merchantAmount',
    header: 'Списано',
    cell: ({ row }) => {
      if (row.original.withdrawStatus !== WithdrawStatus.Paid) return null
      const amount = formatCurrency(row.original.amountFrom, row.original.currencyFrom)

      return (
        <div className="flex flex-col">
          <span>{amount}</span>
        </div>
      )
    },
  },
]
